import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Sidebar } from '@/components/layout/Sidebar';
import { TopBar } from '@/components/layout/TopBar';
import { CrossTabSyncModal } from '@/components/common/CrossTabSyncModal';
import type { RootState } from '@/state/store';

const SIDEBAR_WIDTH    = 240;
const COLLAPSED_WIDTH  = 60;

/** 56px main TopBar + 28px context strip when session context is active */
const TOP_BAR_HEIGHT    = 56;
const CONTEXT_STRIP_H   = 28;

export const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const session = useSelector((s: RootState) => s.session.session);

  // Show the context strip when any context dimension is present
  const hasStrip = !!(
    session?.companyName      ||
    session?.financialYearCode ||
    session?.locationName     ||
    session?.costCenterName
  );

  const topOffset = TOP_BAR_HEIGHT + (hasStrip ? CONTEXT_STRIP_H : 0);

  return (
    // Changed based on Dinisuru's request: Using semantic theme token bg-canvas instead of hardcoded hex
    <div className="min-h-screen bg-canvas">
      {/* Changed based on Dinisuru's request: Protect against multi-tab company session collisions */}
      <CrossTabSyncModal />

      <Sidebar open={sidebarOpen} onToggle={() => setSidebarOpen((o) => !o)} />

      <TopBar
        sidebarOpen={sidebarOpen}
        sidebarWidth={SIDEBAR_WIDTH}
        collapsedWidth={COLLAPSED_WIDTH}
        onToggleSidebar={() => setSidebarOpen((o) => !o)}
      />

      <main
        style={{
          paddingLeft: sidebarOpen ? SIDEBAR_WIDTH : COLLAPSED_WIDTH,
          paddingTop:  topOffset,
        }}
        className="min-h-screen transition-[padding-left,padding-top] duration-200"
      >
        <div className="p-6 max-w-screen-2xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
